import { type ActionEvent, Controller } from "@hotwired/stimulus"

import SearchMapController from "./search_map_controller"

import { urlWithBounds } from "@/helpers/search_map"

export default class FiltersFormController extends Controller<HTMLFormElement> {
  static outlets = ["search-map"]
  declare readonly searchMapOutlet: SearchMapController

  static targets = ["filterLink", "hiddenFieldset"]
  declare readonly filterLinkTarget: HTMLAnchorElement
  declare readonly hiddenFieldsetTargets: HTMLFieldSetElement[]

  connect(): void {
    // Reset form controls so back button behaves as expected
    this.element.reset()
  }

  applyFilter(e: Event): void {
    e.preventDefault()

    const filter = e.target as HTMLElement
    const url = urlWithBounds(filter.dataset.url!, this.searchMapOutlet.mapBounds)

    this.filterLinkTarget.setAttribute("href", url.toString())
    this.filterLinkTarget.click()
  }

  scrollIntoView({ currentTarget }: ActionEvent): void {
    ;(currentTarget as HTMLElement).scrollIntoView({
      behavior: "instant",
      block: "nearest", // To avoid vertical scrolls
      inline: "center"
    })
  }

  // TODO[NEW_SEARCH_PAGE]: Remove this function (and target) when feature switch gone.
  showAll(e: Event): void {
    const button = e.currentTarget as HTMLButtonElement
    const hiddenFilters = this.hiddenFieldsetTargets.find((fieldset) => {
      return button.parentElement?.contains(fieldset)
    })

    hiddenFilters?.removeAttribute("hidden")
    button?.remove()
  }
}
